<template>
  <v-list-item
    v-tooltip="item.text"
    v-bind="$attrs"
    class="select-item"
  >
    <v-list-item-action
      class="select-item__checkbox"
      @click.stop
    >
      <v-checkbox
        v-model="isSelected"
      />
    </v-list-item-action>

    <v-list-item-action
      v-if="item.iconName || item.iconImage"
      class="select-item__icon"
    >
      <StIcon
        v-if="item.iconName"
        :icon-name="item.iconName"
      />
      <img
        v-else
        alt="icon"
        :src="item.iconImage"
      >
    </v-list-item-action>

    <v-list-item-content class="select-item__text">
      <v-list-item-title>
        <span />
        {{ item.text }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>

export default {
  name: 'SelectItemWithIcon',
  components: {
  },
  inheritAttrs: true,
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemAttributes: {
      type: Object,
      default() {
        return {
          'aria-selected': false,
        };
      },
    },
  },
  computed: {
    isSelected: {
      get() {
        return this.itemAttributes['aria-selected'] === 'true';
      },
      set() {
        this.$emit('selected-item', { value: this.item.value });
        return null;
      },
    },
  },
};
</script>

<style scoped lang="scss">
  .select-item {
    padding: 0 !important;

    &__checkbox {
      margin: 18px 0;
    }

    &__text {
      width: 155px;
    }

    &__icon {
      display: flex;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }

  ::v-deep {
    .v-messages {
      display: none !important;
    }

    .v-input {
      &__slot {
        margin-top: 8px;
      }
    }

    .v-input--selection-controls__input i.theme--light {
      color: rgba(0, 0, 0, 0.54);
    }
  }
</style>
